<template>
  <cargo-advance-select
    :select-type="TYPE_NAMES.basic_data_Office"
    :headers="headers"
    :fields="fields"
    :tag-name="tagName"
    :tag-value="tagValue"
    :static-options="staticOptions"
    filterable
    :placeholder="placeholder"
    :callback-params="callbackParams"
    :default-value="defaultValue"
    @enter="$emit('enter')"
    @parentCallBack="data=>$emit('parentCallBack',data)"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'

export default {
  name: 'OfficeWithChildSelect',
  components: { cargoAdvanceSelect },
  props: {
    headers: { type: Array, default: () => [] },
    fields: { type: Array, default: () => [] },
    tagName: { type: String, default: '' },
    tagValue: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    callbackParams: { type: Object, default: null },
    defaultValue: { type: [String, Number, Boolean], default: '' }
  },
  data() {
    return {
      TYPE_NAMES,
      staticOptions: []
    }
  },
  created() {
    const currentOffices = getCacheListByKey(TYPE_NAMES.basic_data_Office)
    const allOffice = [...getCacheListByKey(TYPE_NAMES.basic_data_Office_All)]
    allOffice.sort((a, b) => a.level - b.level)
    const keySet = new Set()
    for (const office of currentOffices) {
      keySet.add(office.uuid)
    }
    this.staticOptions = []
    for (const office of allOffice) {
      if (keySet.has(office.uuid)) {
        this.staticOptions.push(office)
      } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
        keySet.add(office.uuid)
        this.staticOptions.push(office)
      }
    }
  }
}
</script>
